import { Flex, Stack, Text } from '@chakra-ui/react';
import React from 'react';
import MonthTable from './summary/MonthTable';
import CsvExport from './CsvExport';

export default function AdminDashboard() {
    return (
        <Dashboard />
    )
}

const Dashboard = () => {
    {
        return (
            <div>
                <Stack my={5}>
                    <Text fontSize={"xl"} fontWeight={"bold"} textAlign={"center"}>Export CSV File</Text>
                    <CsvExport />
                </Stack>
                <Flex justifyContent={'center'} className="admin_title">
                    <Text fontSize={"xl"} fontWeight={"bold"}>SUMMARY</Text>
                </Flex>

                <Text fontSize="lg" mb={2}>NEW APPLICATIONS</Text>
                <MonthTable />

                {/* <Space />
            <Text fontSize="lg">REISSUE</Text>
            <MonthTable /> */}
            </div>
        )
    }
}
